<template>
  <div class="gallery-container">
    <div class="showcase-header">
      <h1 class="gallery-title">Our Gallery</h1>
    </div>

    <div class="gallery-grid">
      <div class="gallery-item" v-for="i in 14" :key="i" @click="openLightbox(i)">
        <img :src="require(`@/assets/gallery${i}.jpg`)" :alt="`Gallery image ${i}`" class="gallery-img" />
        <div class="image-overlay">
          <div class="overlay-content">
            <span class="magnify-icon">🔍</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 灯箱组件 -->
    <div class="lightbox" v-if="lightboxOpen" @click="closeLightbox">
      <div class="lightbox-content" @click.stop>
        <img :src="require(`@/assets/gallery${currentImage}.jpg`)" :alt="`Gallery image ${currentImage}`" class="lightbox-img" />
        <button class="lightbox-close" @click="closeLightbox">×</button>
        <button class="lightbox-nav prev" @click.stop="prevImage">&#10094;</button>
        <button class="lightbox-nav next" @click.stop="nextImage">&#10095;</button>
        <div class="image-counter">{{ currentImage }} / 16</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GalleryPage',
  data() {
    return {
      lightboxOpen: false,
      currentImage: 1
    };
  },
  methods: {
    openLightbox(imageIndex) {
      this.currentImage = imageIndex;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden'; // 防止背景滚动
    },
    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = 'auto'; // 恢复背景滚动
    },
    nextImage() {
      this.currentImage = this.currentImage === 16 ? 1 : this.currentImage + 1;
    },
    prevImage() {
      this.currentImage = this.currentImage === 1 ? 16 : this.currentImage - 1;
    },
    // 添加键盘导航
    handleKeydown(e) {
      if (!this.lightboxOpen) return;
      
      switch(e.key) {
        case 'Escape':
          this.closeLightbox();
          break;
        case 'ArrowLeft':
          this.prevImage();
          break;
        case 'ArrowRight':
          this.nextImage();
          break;
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
};
</script>

<style scoped>
.gallery-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  padding-top: 120px; /* 添加顶部内边距防止导航栏遮挡 */
}

.showcase-header {
  text-align: center;
  margin-bottom: 3rem;
}

.gallery-title {
  font-size: 3rem;
  color: #FF8B8B;
  font-weight: bold;
  font-family: 'Lobster';
  position: relative;
  display: inline-block;
  margin-bottom: 0.5rem;
}

.gallery-title::after {
  content: '';
  position: absolute;
  width: 50%;
  height: 4px;
  background: linear-gradient(to right, #FFD1D1, #FFE5A3);
  bottom: -10px;
  left: 25%;
  border-radius: 2px;
}

.gallery-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  grid-gap: 20px;
  grid-auto-rows: minmax(200px, auto);
  grid-auto-flow: dense;
}

/* 让某些图片占据更大的空间，创造视觉兴趣 */
.gallery-item:nth-child(4n+1) {
  grid-column: span 1;
  grid-row: span 1;
}

.gallery-item:nth-child(4n+2) {
  grid-column: span 1;
  grid-row: span 2;
}

.gallery-item:nth-child(4n+3) {
  grid-column: span 2;
  grid-row: span 1;
}

.gallery-item:nth-child(4n) {
  grid-column: span 1;
  grid-row: span 1;
}

.gallery-item {
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  cursor: pointer; /* 添加手型光标提示可点击 */
}

.gallery-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.gallery-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform 0.5s ease;
}

.gallery-item:hover .gallery-img {
  transform: scale(1.05);
}

.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 139, 139, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.gallery-item:hover .image-overlay {
  opacity: 1;
}

.overlay-content {
  text-align: center;
  color: white;
  background-color: rgba(88, 53, 37, 0.7);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: scale(0);
  transition: transform 0.3s ease;
}

.gallery-item:hover .overlay-content {
  transform: scale(1);
}

.magnify-icon {
  font-size: 24px;
}

/* 添加彩色边框，与网站其他部分保持一致的风格 */
.gallery-item:nth-child(3n+1) {
  border: 5px solid #FFD1D1;
}

.gallery-item:nth-child(3n+2) {
  border: 5px solid #FFE5A3;
}

.gallery-item:nth-child(3n) {
  border: 5px solid #D6E6F2;
}

/* 灯箱样式 */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.lightbox-content {
  position: relative;
  max-width: 90%;
  max-height: 90%;
}

.lightbox-img {
  max-width: 100%;
  max-height: 90vh;
  display: block;
  box-shadow: 0 0 30px rgba(255, 255, 255, 0.1);
  border-radius: 8px;
}

.lightbox-close {
  position: absolute;
  top: -40px;
  right: -40px;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 139, 139, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s;
}

.lightbox-close:hover {
  background-color: #FF8B8B;
}

.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: rgba(255, 139, 139, 0.7);
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 18px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 0.3s;
}

.lightbox-nav:hover {
  background-color: #FF8B8B;
}

.prev {
  left: -70px;
}

.next {
  right: -70px;
}

.image-counter {
  position: absolute;
  bottom: -40px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(255, 139, 139, 0.7);
  color: white;
  padding: 5px 15px;
  border-radius: 20px;
  font-size: 14px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .gallery-container {
    padding: 1rem;
    padding-top: 100px;
  }

  .gallery-title {
    font-size: 2.5rem;
  }

  .gallery-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    grid-gap: 15px;
  }

  /* 在移动设备上简化布局 */
  .gallery-item:nth-child(n) {
    grid-column: span 1;
    grid-row: span 1;
  }

  /* 只有少数图片保持特殊布局 */
  .gallery-item:nth-child(5n) {
    grid-column: span 2;
  }

  .gallery-item {
    border-width: 3px;
  }
  
  /* 移动设备上的灯箱调整 */
  .lightbox-nav {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
  
  .prev {
    left: -50px;
  }
  
  .next {
    right: -50px;
  }
  
  .lightbox-close {
    top: -35px;
    right: -20px;
    width: 35px;
    height: 35px;
  }
}

/* 为了在非常小的屏幕上也能看到导航按钮 */
@media (max-width: 480px) {
  .prev {
    left: 10px;
  }
  
  .next {
    right: 10px;
  }
  
  .lightbox-nav {
    background-color: rgba(255, 139, 139, 0.5);
  }
}
</style>